/* 人材机数据库 页面 相关接口 */
import http from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'
let headers = {'Content-type': 'application/x-www-form-urlencoded'}
export default {
  // 1. 获取所有的专业章节及地区等信息
  getMajorAndRegion (params) {
    return http.get(`${backendUrl}/data_manage/resource/catalogs`, params)
  },
  // 2. 获取所有的专业章节
  getMajorList (params) {
    return http.get(`${backendUrl}/data_manage/resource/professions`, params)
  },
  // 3. 获取编制人列表
  getAuthors (params) {
    return http.get(`${backendUrl}/data_manage/resource/authors`, params)
  },
  // 4. 根据专业章节获取地区
  getRegions (params) {
    return http.get(`${backendUrl}/data_manage/resource/regions`, params)
  },

  // 5.人材机列表
  queryMaterialList (params) {
    return http.post(`${backendUrl}/data_manage/resource/list`, params, headers)
  },
  // 6.审核人材机数据
  inspectMaterialItem (params) {
    return http.put(`${backendUrl}/data_manage/resource/inspect`, params, headers)
  },

  // 6.1  批量审核 人材机数据
  inspectBatch (query, params) {
    return http.put(`${backendUrl}/data_manage/resource/inspect_batch?` + queryString.stringify(query), params, headers)
  },

  // 7.修改人材机数据
  updateMaterialItem (params) {
    return http.post(`${backendUrl}/data_manage/resource/update`, params, headers)
  },


  // 7.删除人材机数据
  deleteMaterialItem (query) {
    return http.delete(`${backendUrl}/data_manage/resource`, query)
  },

  // 8.移动人材机数据
  moveMaterialItems (params, query) {
    return http.post(`${backendUrl}/data_manage/resource/move`, params, headers)
  },
  // 9.复制人材机数据
  copyMaterialItems (params, query) {
    return http.post(`${backendUrl}/data_manage/resource/copy`, params, headers)
  },

  // 10-1.导出人材机数据
  exportPreMaterialItems (params, query) {
    return http.post(`${backendUrl}/data_manage/resource/pre_export`, params, headers)
  },

  // 10-2.下载人材机数据
  exportMaterialItems (query) {
    let url = `${backendUrl}/data_manage/resource/export?` + queryString.stringify(query)
    window.common.downloadFile(url)
  },
  // 12-1.导出人材机数据Excel
  exportPreMaterialExcel (params, query) {
    return http.post(`${backendUrl}/data_manage/resource/pre_export_excel`, params, headers)
  },
  // 12-2.下载人材机数据Excel
  exportMaterialExcel (query) {
    let url = `${backendUrl}/data_manage/resource/export_excel?` + queryString.stringify(query)
    window.common.downloadFile(url)
  },


  // 11.上传人材机数据
  uploadMaterialItems (params, query) {
    return http.postArr(`${backendUrl}/data_manage/resource/upload?` + queryString.stringify(query), params, {'Content-type': 'multipart/form-data'})
  },

  getCapter (params) {
    return http.get(`${backendUrl}/data_manage/resource/chapter`, params)
  },
  // 12.获取人才机默认地区
  getArea (){
    return http.get(`${backendUrl}/data_manage/resource/excel_region`).then(ret => {
      console.log(ret)
      return ret
    })
  },
  // 13.人才机Excel读取
  postExcel (params, query){
    return http.postArr(`${backendUrl}/data_manage/resource/parse_excel?region=${query}`, params).then(ret => {
      console.log(ret)
      return ret
    })
  },
  // 14.人才机Excel数据导入
  sendExcelData (params, query){
    return http.postArr(`${backendUrl}/data_manage/resource/upload_excel?` + queryString.stringify(query), params).then(ret => {
      console.log(ret)
      return ret
    })
  }
}

